export const generateJan = (inventoryId) => {
    if (inventoryId >= 1000000000) {
      throw new Error("エラー: 在庫IDが10桁を超えています。管理者に連絡してください。");
    }
  
    // IDの桁数に応じてプレフィックスを決定
    let prefix = "201"; // デフォルト
  
    if (inventoryId <= 9999999) {
      prefix = "20137"; // 7桁以下
    } else if (inventoryId <= 99999999) {
      prefix = "2013"; // 8桁
    } else if (inventoryId <= 999999999) {
      prefix = "201"; // 9桁
    }
  
    // `inventoryId` を適切な桁数に `0` 埋め
    const baseJan = prefix + inventoryId.toString().padStart(12 - prefix.length, "0");
  
    // チェックデジットを計算
    const checkDigit = calculateCheckDigit(baseJan);
  
    // 13桁のJANを返す
    return baseJan + checkDigit;
  };
  
  // **✅ チェックデジットの計算関数**
  const calculateCheckDigit = (baseJan) => {
    const digits = baseJan.split("").map(Number);
    const sum = digits.reduce((acc, digit, index) => {
      return acc + digit * (index % 2 === 0 ? 1 : 3);
    }, 0);
    return (10 - (sum % 10)) % 10;
  };
  